/* eslint-disable eqeqeq */
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import custom_1 from "../assets/images/custom_1.svg";
import custom_2 from "../assets/images/custom_2.svg";
import custom_3 from "../assets/images/custom_3.svg";
import custom_4 from "../assets/images/custom_4.svg";
import custom_5 from "../assets/images/custom_5.svg";
import ordered from "../assets/images/ordered.svg";
import available_for_pickup from "../assets/images/available-for-pickup.svg";
import out_for_delivery from "../assets/images/out-for-delivery.svg";
import order_ready from "../assets/images/orderReady.svg";
import delivered from "../assets/images/delivered.svg";

import moment from "moment";
import Review from "./Review";
import ProgressBarMobile from "./ProgressBarMobile";
// import Ordered from "./SVGS/Ordered";
// import OrderReady from "./SVGS/OrderReady";
// import InTransit from "./SVGS/InTransit";
// import OutForDelivery from "./SVGS/OutForDelivery";
// import Delivered from "./SVGS/Delivered";
import apiService from "../api/api.service";
import { setEdd } from "../store/edd";
import { setFeatureSetting } from "../store/featureSetting";

const ProgressBar = ({ order }) => {
  const customStatusIcons = [custom_1, custom_2, custom_3, custom_4, custom_5];

  const {
    tracking_summary,
    tracking_manual,
    created_at,
    tracking_url,
    tracking_detail: logs,
  } = order;
  const {
    trackingStatus: i18n,
    customStatus,
    customMessage: {
      replaceMessage,
      trackingUrl: { isActive, description },
    },
    general: generalSettings,
    reviewQuestions,
    displayStatusBar,
    progressBar,
  } = useSelector((state) => state.settings);
  const { progress_bar } = useSelector((state) => state.i18n);
  const dispatch = useDispatch();
  const [isConnectFB, setIsConnectFB] = useState(false);
  useEffect(() => {
    apiService.get("getAppSettings").then((res) => {
      if (res.data) {
        dispatch(setFeatureSetting(res?.data?.settings));
        setIsConnectFB(res.data.settings.fb_messenger_status);
        const enabledEdd = res?.data?.settings?.enabled_edd;
        // if (enabledEdd == 1) {
        apiService.get("getEddSettings").then((res) => {
          if (res?.status == 200) {
            dispatch(setEdd(res?.data?.data));
          }
        });
        // }
      }
    });
  }, []);
  const checkOrderNoInfo = () => {
    if (
      (tracking_summary === "courier_not_supported" &&
        tracking_manual === "courier_not_supported") ||
      (tracking_summary === "courier_not_supported" && !tracking_manual)
    ) {
      return true;
    }
    return false;
  };

  const trackingStatus =
    tracking_summary === "courier_not_supported"
      ? tracking_manual ?? tracking_summary
      : tracking_summary;

  const listStatus = {
    courier_not_supported: 0,
    information_received: 1,
    pending: 1,
    available_for_pickup: 2,
    in_transit: 3,
    failed_attempt: 4,
    exception: 4,
    expired: 4,
    out_for_delivery: 4,
    delivered: 5,
  };

  const activeIndex = listStatus[trackingStatus] ?? null;

  const isActiveCustomStatus =
    Math.abs(moment(created_at).diff(moment(), "days")) >=
    +customStatus.timeActive;

  let status;
  if (activeIndex === null) {
    if (customStatus.enabled && isActiveCustomStatus) {
      status = customStatus.label;
    } else {
      status = i18n.ordered;
    }
  } else {
    status = i18n[trackingStatus];
  }
  const isInstallFbMessenger = window.facebookChatSettings?.app_status;
  return !displayStatusBar.length ? (
    ""
  ) : (
    <>
      <h2
        className={`text-center omg-result-title`}
        style={{ color: generalSettings.mainColor }}
      >
        {progress_bar.status}:{" "}
        <span className={`omg-tracking-status-${trackingStatus}`}>
          {status}
        </span>
      </h2>
      <p>
        {isInstallFbMessenger && isConnectFB == "1" && (
          <span style={{ marginLeft: "20px" }}>
            <button
              onClick={() =>
                window.document.querySelector(".ot-fb-logo").click()
              }
              className="omg-integration-fb"
            >
              Chat with seller
            </button>
          </span>
        )}
      </p>
      {checkOrderNoInfo() && (
        <div className="omg-custom-message">
          {/* <p className="omg-custom-message-replace mb-5">{replaceMessage}</p> */}
          {isActive && tracking_url && (
            <p className="omg-custom-message-url mb-5">
              {description.length !== 0
                ? description
                : "You might find alternative tracking here:"}{" "}
              <a
                href={tracking_url}
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                click here
              </a>
            </p>
          )}
        </div>
      )}
      {/* {reviewQuestions && (
        <div style={{ float: "right" }} className="omg-review-wrap">
          <Review order={order} />
        </div>
      )} */}

      {activeIndex !== 0 && (
        <>
          <div className="omg-progress">
            {/* ordered */}
            {displayStatusBar.find((item) => item === "Ordered") && (
              <div className="omg-progress__item omg-progress__item--active">
                <div className="omg-progress__image">
                  {/* <img alt="..." width="40" height="40" src={ordered} /> */}
                  {/* <Ordered /> */}
                  <img src={ordered} alt="ordered" />
                </div>
                <div
                  className="omg-progress__description"
                  style={{ width: "110px" }}
                >
                  <div className="omg-progress__title">{i18n.ordered}</div>
                  {/* <div className="omg-time">
                    <div className="omg-time__minor">
                      {moment(created_at).format(generalSettings.dateFormat)}
                    </div>
                  </div> */}
                </div>
              </div>
            )}
            {/* custom status */}
            {(customStatus?.enabled === 1 ||
              customStatus?.enabled === true) && (
              <div
                className={
                  "omg-progress__item" +
                  (isActiveCustomStatus || activeIndex
                    ? " omg-progress__item--active"
                    : "")
                }
              >
                {customStatus.icon > 0 ? (
                  <div className="omg-progress__image">
                    <img
                      src={`${customStatusIcons[customStatus.icon - 1]}?v=1`}
                      alt="ordered"
                    />
                  </div>
                ) : (
                  <div className="omg-progress__image">
                    <div style={{ width: "40px", height: "57px" }} />
                  </div>
                )}
                <div className="omg-progress__description">
                  <div className="omg-progress__title">
                    {customStatus.label}
                  </div>
                  {/* <div className="omg-time">
                    <div className="omg-time__minor">
                      {moment(created_at)
                        .add(customStatus.timeActive, "days")
                        .format(generalSettings.dateFormat)}
                    </div>
                  </div> */}
                </div>
              </div>
            )}
            {/* pending */}
            {activeIndex === 1 &&
              displayStatusBar.find((item) => item === "Ordered") && (
                <div style={{ position: "relative" }}>
                  <div className="omg-progress-half__text omg-pending color-pending omg-progress__item--active">
                    {i18n.pending}
                  </div>
                </div>
              )}

            {/* information received */}
            {displayStatusBar.find((item) => item === "Order Ready") && (
              <div
                className={
                  "omg-progress__item" +
                  (activeIndex >= listStatus.information_received &&
                  !["pending", "courier_not_supported"].includes(trackingStatus)
                    ? " omg-progress__item--active"
                    : "")
                }
              >
                <div className="omg-progress__image">
                  <img src={`${order_ready}?v=1`} alt="ordered" />
                  {/* <OrderReady /> */}
                </div>
                <div className="omg-progress__description">
                  <div className="omg-progress__title">
                    {i18n.information_received}
                  </div>
                  {/* {activeIndex >= 1 &&
                  !!logs?.length &&
                  logs[logs.length - 1] ? (
                    <div className="omg-time">
                      <div className="omg-time__minor">
                        {moment(logs[logs.length - 1].date_time).format(
                          generalSettings.dateFormat
                        )}
                      </div>
                    </div>
                  ) : (
                    ""
                  )} */}
                </div>
              </div>
            )}
            {/* in_transit */}
            {displayStatusBar.find((item) => item === "In transit") && (
              <div
                className={
                  "omg-progress__item" +
                  (activeIndex >= listStatus.in_transit
                    ? " omg-progress__item--active"
                    : "")
                }
              >
                <div className="omg-progress__image">
                  {/* <InTransit /> */}
                  <img src={`${available_for_pickup}?v=1`} alt="ordered" />
                </div>
                <div className="omg-progress__description">
                  <div className="omg-progress__title">{i18n.in_transit}</div>
                  {/* {activeIndex >= 3 &&
                  !!logs?.length &&
                  logs[logs.length - 2] ? (
                    <div className="omg-time">
                      <div className="omg-time__minor">
                        {moment(logs[logs.length - 2].date_time).format(
                          generalSettings.dateFormat
                        )}
                      </div>
                    </div>
                  ) : (
                    ""
                  )} */}
                </div>
              </div>
            )}

            {/* out for delivery */}
            {displayStatusBar.find((item) => item === "Out for delivery") && (
              <div
                className={
                  "omg-progress__item" +
                  (activeIndex >= listStatus.out_for_delivery
                    ? " omg-progress__item--active"
                    : "")
                }
              >
                <div className="omg-progress__image">
                  {/* <OutForDelivery /> */}
                  <img src={`${out_for_delivery}?v=1`} alt="Out for delivery" />
                </div>
                <div className="omg-progress__description">
                  <div className="omg-progress__title">
                    {i18n.out_for_delivery}
                  </div>
                  {/* {activeIndex >= 4 && !!logs?.length && logs[1] ? (
                    <div className="omg-time">
                      <div className="omg-time__minor">
                        {moment(logs[1].date_time).format(
                          generalSettings.dateFormat
                        )}
                      </div>
                    </div>
                  ) : (
                    ""
                  )} */}
                </div>
              </div>
            )}
            {/* delivered */}
            {displayStatusBar.find((item) => item === "Delivered") && (
              <div
                className={
                  "omg-progress__item" +
                  (activeIndex >= listStatus.delivered
                    ? " omg-progress__item--active"
                    : "")
                }
              >
                <div className="omg-progress__image">
                  {/* <Delivered /> */}
                  <img src={`${delivered}?v=1`} alt="Delivered" />
                </div>
                <div className="omg-progress__description">
                  <div className="omg-progress__title">{i18n.delivered}</div>
                  {/* {activeIndex >= listStatus.delivered && logs?.length && (
                    <div className="omg-time">
                      <div className="omg-time__minor">
                        {moment(logs[0].date_time).format(
                          generalSettings.dateFormat
                        )}
                      </div>
                    </div>
                  )} */}
                </div>

                {/* exception */}
                <div
                  className={
                    "omg-progress-half" +
                    (["failed_attempt", "exception", "expired"].includes(
                      trackingStatus
                    )
                      ? " omg-progress__item--active"
                      : "")
                  }
                >
                  <div className="omg-progress-half__text color-exception">
                    {i18n[trackingStatus]}
                    {/* {logs?.length ? (
                      <div className="omg-time">
                        <div className="omg-time__minor">
                          {moment(logs[0].date_time).format(
                            generalSettings.dateFormat
                          )}
                        </div>
                      </div>
                    ) : (
                      ""
                    )} */}
                  </div>
                </div>
              </div>
            )}
          </div>
          <ProgressBarMobile
            src={customStatusIcons[customStatus.icon - 1]}
            order={order}
          />
        </>
      )}
    </>
  );
};

export default ProgressBar;
